//
//
//
//
//
//

import auth from '../auth'
// console.log("auth:%o", auth)
import line from '../data/line'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      openid: '',
      token: '',
      community: '',
      respData: {},
      reqApiDataUrl: null,
      reqType: null,
      dd: null,
      line
    }
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    // detailData: state => state.jw.detailData
  }),
  beforeCreate (){
    // console.log("beforeCreate...")
  },
  created (){
    console.debug(">>>Detail Price state state:%o",this.$store.state)
    // console.log("created...")
    // console.log('get openid:%s', auth.getOpenid())
    // console.log('get token:%s', auth.getToken())
    // console.log("route.query.cm:%s",this.$route.query.cm)
    let cm = auth.getCm()
    let newcm = this.$route.query.cm
    console.debug("newcm:%s, cm:%s", newcm, cm)
    if(typeof(this.$route.query.cm)!= "undefined" && cm != newcm){
      console.debug("update new cm")
      auth.setCm(newcm)
      //this.clearData()
      auth.clearDetailData()
      cm = newcm

      this.community = cm
      console.debug("reqApiData")
      this.openid = auth.getOpenid()
      this.token = auth.getToken()
      this.reqApiData(this.openid, this.token, this.community)
    }
    else{
      this.community = cm
      this.dd = auth.getDetailData()
      console.debug("else dd:%o", this.dd)
      this.load()
    }

    if(typeof(this.$route.query.type)!= "undefined"){
      this.reqType = this.$route.query.type
      // console.log("reqType:%s", this.reqType)
      auth.setCmType(this.reqType)
    }
    // console.debug("detailData:%o", this.detailData)
    //if(!this.detailData){
    /*if (!this.dd){
      console.debug("reqApiData")
      this.openid = auth.getOpenid()
      this.token = auth.getToken()
      this.reqApiData(this.openid, this.token, this.community)
    }
    else
    {
      console.debug("load detailData")
      this.load()
    }
    this.load()
    */
  },
  beforeMount (){
    // console.log("beforeMount...")
  },
  mounted (){
    // console.log("mounted...")

  },
  methods: {
    ...mapMutations([
      'updateData',
      'clearData'
    ]),
    load: function(){
      //let data = this.detailData;
      let data = this.dd;
      // console.log("data:%o", data)
      if(typeof(data) === "undefined" || typeof(data.price) === "undefined" || typeof(data.bj_price) === "undefined"){
        console.error("input data error : " + data)
        return
      }
      // console.log("data:%o", data)
      let price = data.price
      let bj_price = data.bj_price
      // let brief = this.respData.brief

      // console.log("load...price:%o", price)
      var at=[]
      var as=[]
      for (let key in price) {
        let value = price[key]
        at.push(key)
        as.push(price[key])
        //// console.log("key:%s, value:%s", key, price[key])
      }

      var bat=[]
      var bas=[]
      for (let key in bj_price) {
        let value = bj_price[key]
        bat.push(key)
        bas.push(bj_price[key])
        //// console.log("key:%s, value:%s", key, price[key])
      }

      let n = []
      //n.push(brief.name)
      n.push(this.community)
      n.push("北京")
      // console.log("n:%o", n)
      let asyncData = {
        name: n,
        categories: at,
        data: as
      }

      let bjasyncData = {
        categories: bat,
        data: bas
      }

      // console.log("load...asyncData:%o", asyncData)
      // console.log("load...bjasyncData:%o", bjasyncData)

      console.debug("$refs:%o", this.$refs);

      this.$refs.line.mergeOptions({
        legend: {
          // top: 25,
          data: asyncData.name
        },
        yAxis: {
          data: asyncData.categories
        },
        series: [
          {
            name: asyncData.name[0],
            data: asyncData.data
          },
          {
            name: "北京",
            data: bjasyncData.data
          }
        ]
      })

    },
    reqApiData: function(openid, token, community){
      // console.log("openid:%s, token:%s, community:%s", openid, token,community)
      let reqType = auth.getCmType()
      let reqHouseAreaUrl = null
      let req_data = null
      console.debug("reqType:%s, typeof:%s", reqType, typeof(reqType))
      switch(reqType){
        case '1':
          console.debug("bussiness deal")
          req_data = {openid:openid, token:token, bizcycle:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal'
          break;
        case '2':
          console.debug("district deal")
          req_data = {openid:openid, token:token, district:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal'
          break;
        case '3':
          console.debug("city deal")
          req_data = {openid:openid, token:token, city:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal'
          break;
        case '0':
        default:
          console.debug("nearby deal")
          req_data = {openid:openid, token:token, community:community}
          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal'
          break;
      }
      var url = reqHouseAreaUrl
      // console.log("reqHouseArea url:%s", url);
      this.$http.post(url, req_data).then((response) => {
        // console.log("PASS! response:%o", response);
        // console.log("status:%s", response.status);
        // console.log("statusText:%s", response.statusText);
        // console.log("Expires: %s", response.headers.get('Expires'));
        // console.log("body: %o", response.body);
        this.respData = response.body.data
        // this.updateData(response.body.data)
        // // console.log("detailData:%o", this.detailData)
        auth.setDetailData(response.body.data)
       //this.dd = response.body.data
        this.dd = auth.getDetailData()
        // console.log("dd:%o", this.dd)
        if(this.reqType === '0') {
          console.debug("bussiness area")
          // console.log("coin: %d", response.body.data.coin)
          auth.setCoins(response.body.data.coin)
        }
        this.load()
      }, (response) => {
        // error callback
        console.error("FAIL!!! response:%o", response);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailPrice.vue